import CustomBtn from "components/fragments/CustomBtn";
import CustomInput from "components/fragments/CustomInput";
import MenuBtn from "components/fragments/MenuBtn";
import ModalCloseBalanceCf from "components/modals/CloseBalanceConfirmationModal";
import ModalPin from "components/modals/PinVerificationModal";
import ModalSuccessMoneyDrawer from "components/modals/TransactionSuccessModal";
import MoneyCountController from "components/modals/MoneyCountController";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { numberWithTwoDecimals } from "utils/numberFormat";

const initTestInfo = {
  calTxt: "",
  eventTxt: "",
  cashierName: "POS 1",
};

export default function CashDrawerManagement() {
  const btnList = [
    {
      icon: "/img/icons/icon-deposit.svg",
      btnTxt: "นำเงินเข้า",
    },
    {
      icon: "/img/icons/icon-withdraw.svg",
      btnTxt: "นำเงินออก",
    },
    {
      icon: "/img/icons/icon-money-bag.svg",
      btnTxt: "ปิดยอด",
    },
  ];
  const [currentMenu, setCurrentMenu] = useState();
  const navigate = useNavigate();

  const handleOnSubmit = () => {
    setModalPinOpen(!modalPinOpen);
  };

  const [isBtnActive, setIsBtnActive] = useState(false);
  const [startValue, setStartValue] = useState("0.00");
  const [modalPinOpen, setModalPinOpen] = useState(false);
  const [modalSuccessOpen, setModalSuccessOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState({
    headTxt: "",
    headModalTxt: "",
    btnTxt: "",
  });
  const [isResetMoneyController, setIsResetMoneyController] = useState(false);
  const [moneyCountConInfo, setMoneyCountConInfo] = useState(initTestInfo);
  const [viaPaymentInfo, setViaPaymentInfo] = useState({
    transferTotal: 40000,
    otherTotal: 60000,
    cashTotal: 35000,
    diffTotal: 0,
  });
  const [isCloseBalanceConfirm, setIsCloseBalanceConfirm] = useState(false);
  const [modalCloseBalanceCf, setModalCloseBalanceCf] = useState(false);

  useEffect(() => {
    if (startValue > 0) {
      return setIsBtnActive(true);
    }
    setIsBtnActive(false);
  }, [startValue]);

  useEffect(() => {
    if (currentMenu !== 2) {
      setIsResetMoneyController(true);
      setMoneyCountConInfo(initTestInfo);
    }

    switch (currentMenu) {
      case 0:
        setCurrentEvent((prevEvent) => ({
          ...prevEvent,
          headTxt: "นำเงินเข้าครั้งที่",
          headModalTxt: "นำเงินเข้าสำเร็จ",
          btnTxt: "นำเงินเข้า",
        }));
        setMoneyCountConInfo((prevInfo) => ({
          ...prevInfo,
          calTxt: "เพิ่ม",
          eventTxt: "เงินสดนำเข้า",
        }));
        break;
      case 1:
        setCurrentEvent((prevEvent) => ({
          ...prevEvent,
          headTxt: "นำเงินออกครั้งที่",
          headModalTxt: "นำเงินออกสำเร็จ",
          btnTxt: "นำเงินออก",
        }));
        setMoneyCountConInfo((prevInfo) => ({
          ...prevInfo,
          calTxt: "นำออก",
          eventTxt: "เงินสดนำออก",
        }));
        break;
      case 2:
        setCurrentEvent((prevEvent) => ({
          ...prevEvent,
          headTxt: "ปิดยอด",
        }));
        setMoneyCountConInfo((prevInfo) => ({
          ...prevInfo,
          cashierName: "POS 1",
          staffName: "วัสมนต์ จิตรานุพงศ์",
          startTime: "05/19/2020 12:20",
          endTime: "05/19/2020 20:30",
          duration: "08:10:14",
          eventTxt: "เงินสดตั้งต้น",
          startValue: 2500,
          totalDeposit: 2500,
          totalWithDraw: 1000,
          grandTotal: 81000,
        }));
        break;

      default:
        break;
    }
  }, [currentMenu]);

  return (
    <div className="py-[min(4.10vw,42px)] px-[min(4.20vw,43px)] flex flex-col items-center">
      <div className="flex gap-[min(2.64vw,27px)] ml-[min(1.56vw,16px)]">
        <MenuBtn
          onClick={() => {
            navigate(-1);
          }}
          className={
            "aspect-[115/80] w-[min(11.23vw,115px)] shadow-menu-btn btn-main-active pt-[min(1.63vw,16.69px)] pb-0"
          }
          content={
            <div className="flex flex-col items-center gap-[min(1.17vw,12px)]">
              <img
                className="aspect-[39/29] w-[min(3.81vw,39px)] object-contain"
                src={"/img/icons/icon-arrow-back.svg"}
                alt=""
              />
              <div className="text-14 leading-[1.4] text-[#FFF] font-[400] whitespace-nowrap">
                {"กลับช่องทางหลัก"}
              </div>
            </div>
          }
        />
        {btnList &&
          btnList.map((value, index) => {
            return (
              <MenuBtn
                key={index}
                onClick={() => setCurrentMenu(index)}
                className={`aspect-[115/80] w-[min(11.23vw,115px)] shadow-menu-btn ${
                  currentMenu === index ? "bg-[#DFF7E9]" : "bg-[#FFF]"
                } menu-btn-active`}
                content={
                  <div className="flex flex-col items-center gap-[min(1.17vw,12px)]">
                    <img
                      className="aspect-[39/29] w-[min(3.81vw,39px)] object-contain"
                      src={value.icon}
                      alt=""
                    />
                    <div className="text-14 leading-[1.4] text-[#606060] font-[600] whitespace-nowrap">
                      {value.btnTxt}
                    </div>
                  </div>
                }
              />
            );
          })}
      </div>
      {currentMenu !== undefined && (
        <div className="mt-[min(3.03vw,31px)] w-[min(60.55vw,620px)]">
          <div className=" p-[min(2.44vw,25px)] pb-[min(1.46vw,15px)]">
            {currentMenu !== 2 && (
              <div className="flex justify-between">
                <div className="text-20 leading-[2] font-[700] w-[min(26.86vw,275px)]">
                  {currentEvent.headTxt}
                  <span className="ml-[10px]">1</span>
                </div>
                <div className="text-20 leading-[2] font-[700] min-w-[min(22.07vw,226px)]">
                  ยอดเงินตั้งต้นเดิม
                  <span className="ml-[5px]"> 2,500</span>
                </div>
              </div>
            )}
            {currentMenu === 2 && (
              <div className="mb-[min(1.56vw,16px)]">
                <div className="bg-[#EDEDED] w-full h-[min(0.10vw,1px)]"></div>
                <div className="leading-[2] text-20 font-[700]">
                  {currentEvent.headTxt}
                </div>
              </div>
            )}

            <div>
              <MoneyCountController
                startValueObj={{
                  startValue: startValue,
                  setStartValue: setStartValue,
                }}
                info={moneyCountConInfo}
                viaPaymentInfoObj={{
                  viaPaymentInfo: viaPaymentInfo,
                  setViaPaymentInfo: setViaPaymentInfo,
                }}
                isResetObj={{
                  isReset: isResetMoneyController,
                  setIsReset: setIsResetMoneyController,
                }}
                isCloseBalance={currentMenu === 2}
                isCloseBalanceCfObg={{
                  isCloseBalanceConfirm: isCloseBalanceConfirm,
                  setIsCloseBalanceConfirm: setIsCloseBalanceConfirm,
                }}
              />
              <div className="bg-[#EDEDED] w-full h-[min(0.10vw,1px)] mt-[min(1.96vw,20.12px)]"></div>

              {currentMenu !== 2 && (
                <div className="flex justify-center">
                  <CustomBtn
                    onClick={handleOnSubmit}
                    className={`leading-[0.8] min-w-[min(24.71vw,253px)] text-white font-[400] text-16 min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] mt-[min(1.56vw,16px)] mb-[min(0.98vw,10px)] ${
                      isBtnActive ? "btn-main-active" : "disabled-btn"
                    }`}
                    btntxt={currentEvent.btnTxt}
                  />
                </div>
              )}

              {currentMenu === 2 && (
                <>
                  <div className="text-20 leading-[2]">ช่องทางการชำระเงิน</div>
                  <div className="flex text-18 leading-[1.1] gap-[min(3.03vw,31px)]">
                    <div className="w-[min(19.43vw,199px)] mt-[min(2.64vw,27px)] flex-grow-0 flex flex-col gap-[min(1.76vw,18px)]">
                      <div className="flex justify-between">
                        <div className="text-[#606060]">เงินโอน</div>
                        <div className="text-[var(--color-green)]">
                          {numberWithTwoDecimals(viaPaymentInfo.transferTotal)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className="text-[#606060]">อื่นๆ</div>
                        <div className="text-[var(--color-green)]">
                          {numberWithTwoDecimals(viaPaymentInfo.otherTotal)}
                        </div>
                      </div>
                    </div>
                    <div className="mt-[min(2.64vw,27px)] flex-grow flex flex-col gap-[min(0.88vw,9px)]">
                      <div className="flex justify-between pr-[min(7.42vw,76px)]">
                        <div className="text-[#606060]">เงินสด</div>
                        <div className="text-[var(--color-green)]">
                          {numberWithTwoDecimals(viaPaymentInfo.cashTotal)}
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className="text-[#606060]">ยอดนับเงินสด</div>
                        <div className="flex items-center gap-[min(1.27vw,13px)]">
                          <div className="w-[min(13.67vw,140px)]">
                            <CustomInput
                              inputprops={{
                                type: "text",
                                className:
                                  "modal-input text-18 disabled-input text-[var(--color-green)]",
                                readOnly: true,
                                value: numberWithTwoDecimals(startValue),
                                min: 0,
                                onClick: (e) => {
                                  const input = e.target;
                                  input.select();
                                },
                              }}
                            />
                          </div>

                          <CustomBtn
                            onClick={() => {
                              setIsCloseBalanceConfirm(true);
                            }}
                            className={`leading-[0.8] w-[min(5.96vw,61px)] text-white font-[400] text-16 h-[min(2.93vw,30px)] rounded-[min(0.78vw,8px)] btn-main-active`}
                            btntxt={"ยืนยัน"}
                          />
                        </div>
                      </div>
                      <div className="flex justify-between pr-[min(7.42vw,76px)]">
                        <div className="text-[#606060]">Diff</div>
                        <div className="w-[min(13.67vw,140px)]">
                          <CustomInput
                            inputprops={{
                              type: "text",
                              className: `modal-input text-18 disabled-input ${
                                viaPaymentInfo.diffTotal < 0
                                  ? "text-[var(--color-red)]"
                                  : "text-[var(--color-green)]"
                              }`,
                              readOnly: true,
                              value: `${
                                isCloseBalanceConfirm
                                  ? numberWithTwoDecimals(
                                      viaPaymentInfo.diffTotal
                                    )
                                  : "-"
                              }`,
                              min: 0,
                              onClick: (e) => {
                                const input = e.target;
                                input.select();
                              },
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center mt-[min(2.44vw,25px)]">
                    <CustomBtn
                      onClick={() => {
                        setModalPinOpen(true);
                      }}
                      className={`leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-white font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] ${
                        isCloseBalanceConfirm
                          ? "btn-error-active"
                          : "disabled-btn"
                      }`}
                      btntxt={"ปิดยอด"}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <ModalPin
        modalOpenObj={{
          modalOpen: modalPinOpen,
          setModalOpen: setModalPinOpen,
        }}
        modalSuccessOpenObj={{
          modalOpen: currentMenu !== 2 ? modalSuccessOpen : modalCloseBalanceCf,
          setModalOpen:
            currentMenu !== 2 ? setModalSuccessOpen : setModalCloseBalanceCf,
        }}
      />
      <ModalSuccessMoneyDrawer
        modalOpenObj={{
          modalOpen: modalSuccessOpen,
          setModalOpen: setModalSuccessOpen,
        }}
        startValueObj={{
          startValue: startValue,
          setStartValue: setStartValue,
        }}
        isResetMoneyControllerObj={{
          isReset: isResetMoneyController,
          setReset: setIsResetMoneyController,
        }}
        info={{
          headModalTxt: currentEvent.headModalTxt,
        }}
      />
      <ModalCloseBalanceCf
        info={{
          diffTotal: viaPaymentInfo.diffTotal,
        }}
        modalOpenObj={{
          modalOpen: modalCloseBalanceCf,
          setModalOpen: setModalCloseBalanceCf,
        }}
      />
    </div>
  );
}
